module.exports = __webpack_public_path__ + "components/Lightbox/graphic-create-class.png";